import React from 'react';
import PropTypes from 'prop-types';
import fileIcon from '../icons/file-default.png';
import arrowIcon from '../icons/arrow-right-alt.svg';

const RegulationButton = ({ url, filename, filetype, filesize }) => (
  <div className="regulation-button">
    <img className="regulation-button__icon-file" src={fileIcon} />

    <div className="regulation-button__content">
      <div className="regulation-button__file-info">
        {filetype} | {filesize}&nbsp;KB
      </div>
      <div className="regulation-button__title">{filename}</div>
    </div>

    <img className="regulation-button__icon-arrow" src={arrowIcon} />

    <a href={url} target="_blank" className="regulation-button__link" download>
      &nbsp;
    </a>
  </div>
);

RegulationButton.propTypes = {
  url: PropTypes.string.isRequired,
  filename: PropTypes.string.isRequired,
  filetype: PropTypes.string.isRequired,
  filesize: PropTypes.string.isRequired,
};

export default RegulationButton;
